import { render, staticRenderFns } from "./AnimatedText.vue?vue&type=template&id=01b7deb3&scoped=true&"
import script from "./AnimatedText.vue?vue&type=script&lang=js&"
export * from "./AnimatedText.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedText.vue?vue&type=style&index=0&id=01b7deb3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b7deb3",
  null
  
)

export default component.exports